exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hero-gradient[data-v-06725b69]::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1;\n  height: 100%;\n  background: rgb(1, 23, 47);\n  opacity: 70%;\n}\n", ""]);

// exports
